import { render, staticRenderFns } from "./VersionFooter.vue?vue&type=template&id=4c5ecb10&scoped=true"
import script from "./VersionFooter.vue?vue&type=script&lang=js"
export * from "./VersionFooter.vue?vue&type=script&lang=js"
import style0 from "./VersionFooter.vue?vue&type=style&index=0&id=4c5ecb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ecb10",
  null
  
)

export default component.exports